/**
 * 协议契约的本地绑定。
 *
 * 消息类型与运行时校验的**唯一实现**在 `@tickbird-dev/embed-protocol`，宿主与 iframe 共用同一份。
 * 这个文件只做一件事：把嵌入端自己的路由前缀注入父→子解析器。
 *
 * 不要在这里新增协议逻辑，也不要在这里重新实现校验——那正是抽包要消除的两份手抄。
 * 协议本身要改，改包；`web/scripts/check-architecture.mjs` 会挡住 `protocol/` 目录复活。
 *
 * 只导出 iframe 侧该用的那一半：宿主方向的 `parseFrameMessage` 刻意不在这里出现。
 */

import { createParentMessageParser } from "@tickbird-dev/embed-protocol";
import { EMBEDDED_ROUTE_PREFIX } from "@/surfaces/surface";

/** 解析并校验父页面消息；任何不符合契约的输入都返回 null 并被静默丢弃。 */
export const parseParentMessage = createParentMessageParser({ routePrefix: EMBEDDED_ROUTE_PREFIX });

export type {
  EmbeddedBusinessContext,
  EmbeddedLocale,
  EmbeddedNotification,
  EmbeddedTheme,
  EmbeddedThemeMode,
  EmbeddedThemeToken,
  EmbeddedThemeTokens,
  ForbiddenReason,
  ParentMessageType,
  ParentToTickbirdMessage,
  SessionEndReason,
  TickbirdToParentMessage,
  TokenRequiredReason,
  UnsavedWorkReason,
} from "@tickbird-dev/embed-protocol";
export {
  EMBEDDED_PROTOCOL_VERSION,
  EMBEDDED_THEME_TOKEN_PROPERTIES,
  FRAME_MESSAGE,
  isEmbeddedLocale,
  isEmbeddedTheme,
  MAX_NOTIFICATION_BODY_LENGTH,
  MAX_NOTIFICATION_TITLE_LENGTH,
  PARENT_MESSAGE,
  parseEmbeddedNotification,
} from "@tickbird-dev/embed-protocol";
